import api from "api/api";

export const searchUsersByIds = async ({ ids, userScope }) =>
  await api.get(`/directory/search/general/ids/${ids}?scope=${userScope}`);

export const searchGeneralByProfileQuery = async ({
  profile,
  search,
  userScope,
  isPartnerConnection,
  clientTypes,
}) => {
  if (search.length > 2) {
    const clientTypeParams = clientTypes
      ? clientTypes.map((t) => `&client_type=${t}`).join("")
      : "";
    return await api.get(
      `/directory/search/general?profile=${
        profile || ""
      }&search=${encodeURIComponent(search)}&scope=${userScope}${
        isPartnerConnection ? "&is_partner_connection=true" : ""
      }${clientTypeParams}`,
      null,
      { bypassRestriction: true }
    );
  }
  return [];
};

export const searchDavidsonBySirenQuery = async ({
  siren,
  entity,
  userScope,
}) =>
  await api.get(
    `directory/search/siren/${siren}?entity=${entity}&scope=${userScope}`
  );

const appendArrayParams = (params, key, values, unique = false) => {
  if (Array.isArray(values) && values.length > 0) {
    const itemsToAppend = unique ? [...new Set(values)] : values;
    itemsToAppend.forEach((val) => params.append(key, val));
  }
};

export const getNamesByFiltersQuery = async ({
  types,
  slug,
  names,
  state,
  id,
  profile,
  manager_of_id,
  search,
  role,
  include_deleted,
  allowed_scope,
  assigned_branches_include_contract,
}) => {
  const params = new URLSearchParams();

  appendArrayParams(params, "type", types);
  appendArrayParams(params, "profile", profile);
  appendArrayParams(params, "id", id, true);

  if (manager_of_id) {
    const managers = Array.isArray(manager_of_id) ? manager_of_id : [manager_of_id];
    managers.forEach((e) => params.append("or-manager-of-id", e));
  }

  if (Array.isArray(role) && role.length > 0) {
    appendArrayParams(params, "role", role, true);
  } else if (role) {
    params.append("role", role);
  }

  if (slug) params.append("slug", slug);
  if (names) params.append("names", names);
  if (state) params.append("state", state);
  if (search) params.append("search", search);
  if (include_deleted) params.append("include_deleted", include_deleted);
  if (allowed_scope) params.append("allowed-scope", allowed_scope);
  if (assigned_branches_include_contract) {
    params.append("assigned-branches-include-contract", "true");
  }

  const queryString = params.toString();

  return await api.get(`directory/search/name?${queryString}`);
};
